import { useGlobalState } from 'Data/context/GlobalState';
import { useStateWithRef } from 'Lib/hooks/useStateWithRef';
import { useEffect } from 'react';

export const usePersistentFiltering = (filterDataKey, defaultFilter) => {
  const [globalState, updateGlobalState] = useGlobalState();
  const [filterBy, setFilterBy, filterRef] = useStateWithRef();

  useEffect(() => {
    let cachedFilter = globalState[filterDataKey];
    if (
      defaultFilter &&
      (!cachedFilter || !Object.entries(cachedFilter).length)
    ) {
      setFilterBy(defaultFilter);
    } else {
      setFilterBy(cachedFilter || {});
    }
    return () => {
      updateGlobalState(filterDataKey, filterRef.current);
    };
  }, []);

  const updateFilterField = (field, value) => {
    let newValue = !value || !`${value}`.length ? null : value;
    setFilterBy((prevValue) => {
      if (newValue) {
        return { ...prevValue, [field]: newValue };
      } else if (prevValue && prevValue[field]) {
        let newObject = { ...prevValue };
        delete newObject[field];
        return newObject;
      }
      return prevValue || {};
    });
  };

  return [filterBy, updateFilterField];
};
